export default __webpack_public_path__ + "static/media/package3.f0fc0b53.png";